import { all, fork, put, takeEvery } from "redux-saga/effects";
import * as api from "../../api";

import { FETCH_BRANCHES } from "../actions";

import { fetchBranchesSuccess, fetchBranchesError } from "./actions";

function* fetchAllBranches() {
  const req = yield api.getData("/git/branches");

  if (req.status === 200) {
    const data = yield req.json();
    yield put(fetchBranchesSuccess(data));
  } else {
    yield put(fetchBranchesError(req.error.message));
  }
}

function* watchFetchBranches() {
  return yield takeEvery(FETCH_BRANCHES, fetchAllBranches);
}

export default function* rootSaga() {
  yield all([fork(watchFetchBranches)]);
}
